import { intl } from '../utils/intl';
const t = (id) => intl.formatMessage({ id });

/**
 * General constants used in ID360
 */

export const ASSET_SECTIONS = ['Mechanical', 'Electric', 'Plumbing', 'Waste', 'Fire', 'Gas', 'Room', 'Window_Plans', 'Reflective_Ceiling_Plans', 'Storefronts'];
export const ASSET_SECTION_LABELS = {
  'Mechanical': t('assetSchema.section.mechanical'),
  'Electric': t('assetSchema.section.electrical'),
  'Plumbing': t('assetSchema.section.plumbing'),
  'Waste': t('assetSchema.section.waste'),
  'Fire': t('assetSchema.section.fire'),
  'Gas': t('assetSchema.section.gas'),
  'Room': t('assetSchema.section.room'),
  'Window_Plans': t('assetSchema.section.window'),
  'Reflective_Ceiling_Plans': t('assetSchema.section.reflective'),
  'Storefronts': t('assetSchema.section.storefronts'),
  'Overview': t('assetSchema.headers.overview'),
  'Space Overview': t('assetSchema.headers.space_overview'),
  'Floorplans': t('assetSchema.headers.floorplans'),
  'Thickness': t('assetSchema.headers.thickness'),
  'Outer Unit Corner to Outer Block Corner': t('assetSchema.headers.outer_unit_corner_to_outer_block_corner'),
  'Unit Overview': t('assetSchema.headers.unit_overview'),
  'Flooring': t('assetSchema.headers.flooring'),
  'Ceiling Information': t('assetSchema.headers.ceiling_information'),
  'Construction Overview': t('assetSchema.headers.construction_overview'),
  'Property Features': t('assetSchema.headers.property_features'),
  'Other': t('assetSchema.headers.other')
};

// space profile status constants
export const PUBLISHED = 'published';
export const UNPUBLISHED = 'unpublished';
export const DRAFT = 'draft';
export const TEAR_SHEET = 'tear sheet';
export const NOT_PRESENT = 'Not Present';

// space profile status constants (translations)
export const STATUS_LABELS = { [PUBLISHED]: t('term.published'), [UNPUBLISHED]: t('term.unpublished'), [DRAFT]: t('term.draft') }

// Floor labels for profiles. Consumer will need to dynamically add level 1-99
export const FLOOR_NAMES = ['Basement 1', 'Basement 2', 'Ground Floor', 'Main Floor', 'Mezzanine']
export const FLOOR_LABELS = { 'Basement 1': t('floorLabels.basement1'), 'Basement 2': t('floorLabels.basement2'), 'Ground Floor': t('floorLabels.groundFloor'), 'Main Floor': t('floorLabels.mainFloor'), 'Mezzanine': t('floorLabels.mezzanine') }

export const SALES_EMAIL = 'sales@idplans.com'
